<script>
export default {
    name: "PatientChargesPrint",

    data() {

        return {
            charges: [],
            patient: {},
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchPatient(), this.fetchChargeDetails(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchChargeDetails() {

            return this.$http.get(`PatientReports/GetPatientCharges?VisitNo=${this.$route.query.visitNo}`)
                .then(response => {
                    this.charges = response.data;
                }).catch(() => {});
        },

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.query.patientID}`).then(response => {
              this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full my-2 text-center">
            <h5 class="font-medium uppercase">Patient Charges</h5>
        </div>
        <div class="w-full flex flex-wrap p-1 my-2">
            <div class="flex-1">
                <h5 class="font-semibold text-sm">Name: {{ patient.names }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-semibold text-sm">Diagnosis: {{ patient.diagnosis }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-semibold text-sm">Seen By: {{ patient.userName }}</h5>
            </div>
        </div>
        <table class="table table-bordered">
            <thead class="text-sm">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">Balance</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(charge, idx) in charges" :key="idx">
                    <td class="p-tiny">{{ charge.sysDate | dateFormat }}</td>
                    <td class="p-tiny">{{ charge.userName }}</td>
                    <td class="p-tiny">{{ charge.itemName }}</td>
                    <td class="p-tiny">{{ charge.quantity }}</td>
                    <td class="p-tiny">{{ charge.grandTotal | numberFormat }}</td>
                    <td class="p-tiny">{{ charge.balance }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>